import type { TableColumnDefinition } from "$components/table";
import type { IntlShape } from "react-intl";

export const getViewColumns = (
  formatMessage: IntlShape["formatMessage"],
): TableColumnDefinition[] => [
  {
    field: "createdAt",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.createdAt",
      defaultMessage: "Date",
    }),
    width: 80,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "name",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.name",
      defaultMessage: "Name",
    }),
    width: 150,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "cardNumber",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.cardNumber",
      defaultMessage: "Card number",
    }),
    width: 130,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "dob",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.dateOfBirth",
      defaultMessage: "DOB",
    }),
    width: 80,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "gender",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.gender",
      defaultMessage: "Gender",
    }),
    width: 65,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "age",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.age",
      defaultMessage: "Age",
    }),
    width: 65,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "address",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.address",
      defaultMessage: "Address",
    }),
    width: 150,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "state",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.state",
      defaultMessage: "State",
    }),
    width: 100,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "phoneNumber",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.phoneNumber",
      defaultMessage: "Phone Number",
    }),
    width: 130,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "firstContact",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.firstContact",
      defaultMessage: "First contact",
    }),
    width: 80,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "nextOfKinName",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.nextOfKin.name",
      defaultMessage: "Next of kin name",
    }),
    width: 150,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "nextOfKinAddress",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.nextOfKin.address",
      defaultMessage: "Next of kin address",
    }),
    width: 150,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "nextOfKinRelationship",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.nextOfKin.relationship",
      defaultMessage: "Next of kin relationship",
    }),
    width: 100,
    verticalAlignContents: "top",
    alignContents: "left",
  },
  {
    field: "nextOfKinPhoneNumber",
    headerName: formatMessage({
      id: "nigeriaGeneralAttendance.header.nextOfKin.phoneNumber",
      defaultMessage: "Next of kin phone number",
    }),
    width: 130,
    verticalAlignContents: "top",
    alignContents: "left",
  },
];
